import { fetchApi } from '@/config/axiosSetting';
import { GetDamagedImagesTabsQueryParamsType, GetDamagedImagesTabsQueryResponseType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDamagedImagesTabs/getDamagedImagesTabsQuery.type';

export const getDamagedImagesTabsFunction = (
  params: GetDamagedImagesTabsQueryParamsType,
): Promise<GetDamagedImagesTabsQueryResponseType> => {
  return fetchApi.get(`/property/reports/${params.id}/accident_users/damaged/images/entry_tabs/`, { params });
};
